export default {
  cancellation: {
    DESC_UNKNOWN: '无效的取消政策',
    DESC_NO_CANCELLATION_AFTER_ISSUED: '票券兑换后或活动开始后不可取消。',
    DESC_UPTO_X_DAYS_BEFORE_WITH_CHARGE:
      '自预订确认日起至参加日（{{if(P1>0)为{{P1}}天前else当日}}）当地时间{{P2}}前，{{CancellationFeeDescription}}。',
    DESC_UPTO_X_HOURS_BEFORE_WITH_CHARGE:
      '自预订确认日起至参加时间{{P1}}小时前，{{CancellationFeeDescription}}。',
    DESC_AFTER_X_DAYS_FROM_TIME_WITH_CHARGE:
      '参加日前{{P1}}天当地时间{{P2}}之后，{{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_TIME_WITH_CHARGE:
      '参加时间{{P1}}小时前之后，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_DAYS_WITH_CHARGE:
      '自参加日前{{P1}}天当地时间{{P2}}至{{P3}}天前当地时间{{P4}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_DAYS_TO_Y_HOURS_WITH_CHARGE:
      '自参加日前{{P1}}天当地时间{{P2}}至当日当地时间{{P3}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_TO_Y_HOURS_WITH_CHARGE:
      '自参加时间{{P1}}小时前至{{P2}}小时前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_X_HOURS_TO_0_WITH_CHARGE:
      '自参加时间{{P1}}小时前至当日当地时间{{P2}}，{{CancellationFeeDescription}}',
    DESC_BEFORE_X_DAYS_AFTER_BOOKING_WITH_CHARGE:
      '以预订确认日为第0天计算，第{{P2}}天当地时间{{P1}}前，{{CancellationFeeDescription}}',
    DESC_BEFORE_X_HOURS_AFTER_BOOKING_WITH_CHARGE:
      '预订确认后{{P1}}小时前，{{CancellationFeeDescription}}',
    DESC_AFTER_X_DAYS_FROM_BOOKING_WITH_CHARGE:
      '以预订确认日为第0天计算，第{{P2}}天当地时间{{P1}}之后，{{CancellationFeeDescription}}',
    DESC_AFTER_X_HOURS_FROM_BOOKING_WITH_CHARGE:
      '预订确认后{{P1}}小时之后，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_DAYS_WITH_CHARGE:
      '以预订确认日为第0天计算，第{{P2}}天当地时间{{P1}}至参加日前{{P4}}天当地时间{{P3}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_AND_X_HOURS_WITH_CHARGE:
      '以预订确认日为第0天计算，第{{P2}}天当地时间{{P1}}至参加时间{{P3}}小时前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_AND_X_HOURS_WITH_CHARGE:
      '预订确认后{{P1}}小时至参加时间{{P2}}小时前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_END_WITH_CHARGE:
      '以预订确认日为第0天计算，第{{P2}}天当地时间{{P1}}至第{{P4}}天当地时间{{P3}}，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_DAYS_START_AND_HOURS_WITH_CHARGE:
      '以预订确认日为第0天计算，第{{P2}}天当地时间{{P1}}至预订确认后{{P3}}小时前，{{CancellationFeeDescription}}',
    DESC_BETWEEN_BOOKING_HOURS_START_AND_END_WITH_CHARGE:
      '预订确认后{{P1}}小时至{{P2}}小时前，{{CancellationFeeDescription}}'
  },
  cancellationFeeDescription: {
    FEE_PERCENTAGE: '将收取订单总额{{value}}%作为取消费用',
    FEE_FIXED: '将收取{{value}}作为取消费用',
    FEE_PER_PARTICIPANT: '将按每位参与者收取{{value}}作为取消费用',
    FEE_NOT_TO_BE_CANCELLED: '不可取消'
  }
};
